/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeEvery, select } from 'redux-saga/effects'

import { CookieConstants } from '../store/cookie.constants'

import { getCookieSelector } from '../selectors'

export function* setCookie() {
  const cookie = yield select(getCookieSelector)
  document.cookie = `hzl-origin=${cookie.toLowerCase()}`
  // todo: add toast message
}

export function* setCookieSaga() {
  yield takeEvery([CookieConstants.ON_SET_COOKIE], setCookie)
}
